import React from 'react';
import { RadioSymbol } from 'ui';
import { DefaultFiltersTranslation } from '../constants';
import { getFilterId } from '../utils/get-filter-id';
import { DefaultFilter, DefaultFilterValidation, FilterState } from '../types-store';

interface FilterDefaultValueProps {
  filter: DefaultFilter;
  updateFilter: (domainId: number, filter: DefaultFilter, validation: DefaultFilterValidation) => void;
  translation: DefaultFiltersTranslation;
  children?: React.ReactNode;
}

export const FilterDefaultValue: React.FC<FilterDefaultValueProps> = ({
  filter, updateFilter, translation, children
}) => {

  const noDefaultValueId = getFilterId(filter.domain?.value, 'noDefaultValue');
  const useDefaultValueId = getFilterId(filter.domain?.value, 'useDefaultValue');

  const changeFilterToNoDefaultValue = () => {

    updateFilter(
      filter.domain?.value,
      {
        ...filter,
        defaultValue: undefined,
        defaultValue2: undefined,
        myValue: false,
        periodPredef: undefined,
        state: FilterState.NoDefaultValue
      },
      {}
    );
  };

  const changeFilterToUseDefaultValue = () => {
    updateFilter(
      filter.domain?.value,
      {
        ...filter,
        state: FilterState.DefaultValue
      },
      {}
    );
  };

  return <>
    <div className="form-check">
      <input
        id={`${noDefaultValueId}-select`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={FilterState.NoDefaultValue}
        checked={filter.state === FilterState.NoDefaultValue}
        onChange={changeFilterToNoDefaultValue} />
      <label
        htmlFor={`${noDefaultValueId}-select`}
        className="form-check-label">
        <RadioSymbol />
        <b>{translation.no_default_value}</b>
      </label>
    </div>
    <div className="form-check">
      <input
        id={`${useDefaultValueId}-select`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={FilterState.DefaultValue}
        checked={filter.state === FilterState.DefaultValue}
        onChange={changeFilterToUseDefaultValue} />
      <label
        htmlFor={`${useDefaultValueId}-select`}
        className="form-check-label">
        <RadioSymbol />
        <b>{translation.use_default_value}</b>
      </label>
      {filter.state === FilterState.DefaultValue && children}
    </div>
  </>;
};
